export const environment = {
  production: false,
  user: 'cwsoa',
  password: 'cwsoa1'
};
